import React from "react";

// ----------------------------  ReviewHeader  ----------------------------
// The inspection question and, on object presence records, the object judged with
// Prev / Next arrows. Shown above the field rows, and above the override summary.

// Object presence records: which object is on screen and how to move between them.
export interface ObjectNav {
  index: number;
  total: number;
  onPrev: () => void;
  onNext: () => void;
}

interface ReviewHeaderProps {
  question: string | null;
  // set on object presence records
  objectName?: string;
  objectNav?: ObjectNav;
}

const ReviewHeader: React.FC<ReviewHeaderProps> = ({ question, objectName, objectNav }) => (
  <>
    {question && <div style={questionBanner}>{question}</div>}
    {objectName !== undefined && (
      <div style={objectBar}>
        {objectNav && objectNav.total > 1 && (
          <div style={{ display: "flex", gap: "4px", flexShrink: 0 }}>
            <button
              type="button"
              style={objectNavBtn}
              onClick={objectNav.onPrev}
              aria-label="Previous object"
              title="Previous object"
            >
              {"\u2039"}
            </button>
            <button
              type="button"
              style={objectNavBtn}
              onClick={objectNav.onNext}
              aria-label="Next object"
              title="Next object"
            >
              {"\u203A"}
            </button>
          </div>
        )}
        <div style={{ flex: 1, minWidth: 0 }}>
          {objectNav && (
            <div style={objectCounter}>
              Object {objectNav.index + 1} of {objectNav.total}
            </div>
          )}
          <div style={objectTitle}>{objectName}</div>
        </div>
      </div>
    )}
  </>
);

// ----------------------------  Styles  ----------------------------

const questionBanner: React.CSSProperties = {
  padding: "10px 14px",
  fontWeight: 400,
  fontSize: "1.3rem",
  color: "#1e3a5f",
  background: "#f0f7ff",
  borderRadius: "6px 6px 0 0",
  border: "1px solid #bfdbfe",
  borderBottom: "none",
};

const objectBar: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: "10px",
  padding: "8px 14px",
  background: "#fffbeb",
  border: "1px solid #fde68a",
  borderRadius: "0 0 6px 6px",
  marginBottom: "8px",
};

const objectCounter: React.CSSProperties = {
  fontSize: "1.1rem",
  fontWeight: 600,
  textTransform: "uppercase",
  letterSpacing: "0.04em",
  color: "#b45309",
};

const objectTitle: React.CSSProperties = {
  fontSize: "1.4rem",
  fontWeight: 600,
  color: "#1f2937",
  wordBreak: "break-word",
};

const objectNavBtn: React.CSSProperties = {
  border: "1px solid #d1d5db",
  background: "white",
  borderRadius: "6px",
  padding: "4px 12px",
  fontSize: "1.6rem",
  lineHeight: 1,
  color: "#374151",
  cursor: "pointer",
  flexShrink: 0,
};

export default ReviewHeader;
